import { GET_COVER_PREVIEW } from 'modules/editor/store/constants';

export const getCoverPreview = () => ({
  type: GET_COVER_PREVIEW,
});
